module.exports = __webpack_public_path__ + "img/candy_icon.1c0a772e.svg";